<template>
  <div class="reder-ai-container">
    <el-button class="back el-icon-arrow-left" plain @click="goBack"
      >返回</el-button
    >
    <div class="reder-container">
      <iframe
      :src="iframeSrc"
      width="100%"
      height="100%"
      style="border: none"
    ></iframe>
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    sourceType: {
      type: String,
      default: ''
    },
    sourceId: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState(['userInfo']),
    userId() {
      // 优先从 userInfo 拿，没有就从 localStorage 拿
      return this.userInfo?.userId || localStorage.getItem('standardUserId') || ''
    },
    schoolCode() {
      // 优先从 userInfo 拿，没有就从 localStorage 拿
      return this.userInfo?.schoolCode  || ''
    },
    // 获取 sourceType，优先从 props，然后从路由查询参数，最后使用默认值
    finalSourceType() {
      return this.sourceType || this.$route?.query?.sourceType || 'reach'
    },
    // 获取 sourceId，优先从 props，然后从路由查询参数，最后使用默认值
    finalSourceId() {
      return this.sourceId || this.$route?.query?.sourceId || '1'
    },
    iframeSrc() {
      console.log('当前userId:', this.userId)
      const src = `https://hyx.xueduoduo.com/video-word?userId=${this.userId}&schoolCode=${this.schoolCode}&sourceType=${this.finalSourceType}&sourceId=${this.finalSourceId}`
      console.log('iframeSrc:', src)
      return src
    }
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'detailResearchMng' })
    }
  }
}
</script>

<style lang="less" scoped>
.reder-ai-container {
  height: calc(100%);
  position: relative;

  .back {
    margin: 10px 20px;
  }
}

.reder-container {
  height: calc(100% - 60px);
  position: relative;

  .back {
    margin: 10px 20px;
  }
}

</style>



